import { render, staticRenderFns } from "./DiscoveryForm.vue?vue&type=template&id=664ec9a5&scoped=true&"
import script from "./DiscoveryForm.vue?vue&type=script&lang=js&"
export * from "./DiscoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryForm.vue?vue&type=style&index=0&id=664ec9a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ec9a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
